import React, { useEffect, useState } from 'react';
import { ChevronDown } from 'lucide-react';

import api from '../../api/axios';
import {cn} from '../../lib/utils'
import { DropdownMenuTrigger , DropdownMenu, DropdownMenuContent, DropdownMenuItem} from '../ui/dropdown-menu';
export const ReasonFilterDropdown = ({
  selectedReason = 'all',
  onReasonChange,
  isDark = false,
}) => {
  const [reasons, setReasons] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchReasons = async () => {
      setLoading(true);
      try {
        const result = await api.get('/api/levy-automations/review-reasons');
        console.log(result)
        if (result.data.success && Array.isArray(result.data.data)) {
          setReasons(result.data.data);
        }
      } catch (err) {
        console.error('Failed to load review reasons', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReasons();
  }, []);

  const selectedReasonLabel = selectedReason === 'all'
    ? 'All'
    : reasons.find(r => r.id === selectedReason)?.name || selectedReason;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          disabled={loading}
          className={cn(
            "border-solid border-[1px] flex items-center justify-between gap-[8px] h-[40px] px-[16px] py-[6px] rounded-[12px] text-[15px] font-normal cursor-pointer transition-colors duration-200 whitespace-nowrap min-w-[200px] max-w-[320px]"
          )}
          style={{
            backgroundColor: isDark ? '#161515' : '#ffffff',
            borderColor: isDark ? '#292929' : '#d9d9d9',
            color: isDark ? '#f2f2f2' : '#072837',
            filter: 'drop-shadow(0px 0px 50px rgba(0, 0, 0, 0.05))',
          }}
        >
          <span className="truncate">
            {loading ? 'Loading reasons...' : `Reason: ${selectedReasonLabel}`}
          </span>
          <ChevronDown
            className="w-[14px] h-[14px] shrink-0 transition-colors duration-200"
            style={{ color: isDark ? '#f2f2f2' : '#072837' }}
          />
        </button>
      </DropdownMenuTrigger>

      <DropdownMenuContent
        align="start"
        className={cn(
          isDark ? 'bg-[#161515] border-[#292929]' : 'bg-white border-[#d9d9d9]',
          "border border-solid border-[1px] rounded-[12px] p-0 overflow-hidden max-h-[300px] overflow-y-auto w-[320px] z-50"
        )}
      >
        <DropdownMenuItem
          className={cn(
            isDark
              ? selectedReason === 'all'
                ? 'bg-[#cd6d2c] text-[#161515]'
                : 'bg-[#161515] text-[#f2f2f2] hover:bg-[#222222] hover:text-[#cd6d2c]'
              : selectedReason === 'all'
                ? 'bg-[#072837] text-white'
                : 'bg-white text-[#072837] hover:!bg-[#f5f5f5]',
            "text-[13px] font-medium px-[16px] py-[10px] cursor-pointer transition-colors duration-200"
          )}
          onClick={() => onReasonChange('all')}
        >
          All Reasons
        </DropdownMenuItem>

        {reasons.map((item) => {
          const isSelected = selectedReason === item.id;
          console.log('item', item)
          return (
            <DropdownMenuItem
              key={item.id}
              className={cn(
                isDark
                  ? isSelected
                    ? 'bg-[#cd6d2c] text-[#161515]'
                    : 'bg-[#161515] text-[#f2f2f2] hover:bg-[#222222] hover:text-[#cd6d2c]'
                  : isSelected
                    ? 'bg-[#072837] text-white hover:!bg-[#072837]'
                    : 'bg-white text-[#072837] hover:!bg-[#f5f5f5]',
                "text-[13px] font-medium px-[16px] py-[10px] cursor-pointer transition-colors duration-200 whitespace-normal leading-[1.35]"
              )}
              onClick={() => onReasonChange(item.id)}
            >
              {item.name}
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};